export default {
  page: state => id => state.pages[id]
};
